import React from 'react'

export function PlannerIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect
        x='1'
        y='2'
        width='22'
        height='20'
        rx='1'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path
        stroke='currentColor'
        strokeWidth='2'
        d='M8 6h12M4 10h8M14 10h2M4 6h2M4 14h4M14 14h6M4 18h8M14 18h6'
      />
    </svg>
  )
}
